import { defineMessages } from '@/shared/i18n/define';

/**
 * Textos de la parte PWA: aviso de instalación, aviso de versión nueva, insignia sin conexión y
 * estados de las notificaciones push (la pantalla de Ajustes/Alertas los reutiliza).
 */
export const pwaMsgs = defineMessages(
  'pwa',
  {
    install: {
      title: 'Instala Pizarra Agro',
      body: 'Ábrela desde tu pantalla de inicio como una app y consulta los últimos precios aunque no tengas señal.',
      action: 'Instalar',
      dismiss: 'Ahora no',
      iosTitle: 'Añade Pizarra Agro a tu inicio',
      iosIntro: 'En Safari no hay botón de instalar, pero toma un momento:',
      iosStep1: 'Toca el botón Compartir (el cuadrado con la flecha hacia arriba).',
      iosStep2: 'Elige «Añadir a inicio» (en algunas versiones dice «Agregar a inicio»).',
      iosStep3: 'Confirma con «Añadir». La verás en tu pantalla de inicio como cualquier app.',
    },
    update: {
      title: 'Hay una versión nueva',
      body: 'Actualiza para tener las últimas mejoras. La página se recargará.',
      action: 'Actualizar',
    },
    offline: {
      label: 'Sin conexión',
      detail: 'Estás sin conexión: verás la última copia guardada de los precios.',
    },
    pushStatus: {
      unsupported: 'Este navegador no permite recibir avisos push.',
      denied:
        'Bloqueaste las notificaciones de este sitio. Actívalas en los ajustes del navegador.',
      default: 'Te avisamos cuando se cumpla una alerta, aunque tengas la app cerrada.',
      subscribed: 'Los avisos push están activos en este dispositivo.',
      loading: 'Un momento…',
    },
    pushAction: {
      enable: 'Activar avisos en este dispositivo',
      disable: 'Desactivar avisos en este dispositivo',
    },
    pushError: {
      permission: 'No diste permiso para las notificaciones.',
      browser: 'El navegador no pudo activar los avisos. Inténtalo de nuevo.',
      server: 'No pudimos registrar este dispositivo en tu cuenta. Inténtalo de nuevo.',
    },
  },
  {
    install: {
      title: 'Install Pizarra Agro',
      body: 'Open it from your home screen like an app and check the latest prices even without signal.',
      action: 'Install',
      dismiss: 'Not now',
      iosTitle: 'Add Pizarra Agro to your home screen',
      iosIntro: 'Safari has no install button, but it only takes a moment:',
      iosStep1: 'Tap the Share button (the square with an arrow pointing up).',
      iosStep2: 'Choose “Add to Home Screen”.',
      iosStep3: 'Confirm with “Add”. It will appear on your home screen like any other app.',
    },
    update: {
      title: 'A new version is available',
      body: 'Update to get the latest improvements. The page will reload.',
      action: 'Update',
    },
    offline: {
      label: 'Offline',
      detail: 'You are offline: you will see the last saved copy of the prices.',
    },
    pushStatus: {
      unsupported: 'This browser cannot receive push notifications.',
      denied: 'You blocked notifications for this site. Enable them in your browser settings.',
      default: 'We let you know when an alert triggers, even with the app closed.',
      subscribed: 'Push notifications are on for this device.',
      loading: 'One moment…',
    },
    pushAction: {
      enable: 'Turn on notifications on this device',
      disable: 'Turn off notifications on this device',
    },
    pushError: {
      permission: 'You did not grant permission for notifications.',
      browser: 'The browser could not turn notifications on. Please try again.',
      server: 'We could not register this device on your account. Please try again.',
    },
  },
);
